const BookingDataImportType = {
  New: "NEW_IMPORT",
  Incremental: "INCREMENTAL",
};

export default Object.freeze(BookingDataImportType);
